import {
  get,
  isArray,
  isObject,
} from 'lodash-es';

import { MENU_ITEM__QUESTIONNAIRES__AVAILABLE } from '../../../constants';

const convertFieldToApiFormat = (result, schema, uiSchema, currentSchemaKey, values, key) => {
  let fieldType = get(schema, [...currentSchemaKey, 'type']);
  let fieldWidget = get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), 'ui:widget']);
  if (fieldType === 'array') {
    fieldType = get(schema, [...currentSchemaKey, 'items', 'type']);
    fieldWidget = get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), 'items', 'ui:widget']);
  }

  switch (fieldType) {
    case 'string': {
      const format = get(schema, [...currentSchemaKey, 'format']);
      if (format === 'data-url') {
        if (values[key]) {
          const value = values[key].split(';');
          result.push({
            name: key,
            value: value[2].substring(value[2].indexOf(',') + 1),
            fileName: value[1].substring(value[1].indexOf('=') + 1),
          });

          break;
        }
      }

      let setNullWhenValueIsEmpty = false;

      if (
        fieldWidget
        && [
          'DateFieldWidget',
          'DateTimeFieldWidget',
          'TimeFieldWidget',
          'ContactFieldWidget',
          'ExternalOrganizationFieldWidget',
          'ExternalUserFieldWidget',
          'OrganizationUnitFieldWidget',
          'UserFieldWidget',
        ].includes(fieldWidget)
      ) {
        setNullWhenValueIsEmpty = true;
      }

      if (isArray(values[key])) {
        // Wartość wielokrotna.

        if (setNullWhenValueIsEmpty) {
          result.push({
            name: key,
            values: values[key].map((value) => value || null),
          });
        } else {
          result.push({
            name: key,
            values: values[key],
          });
        }
      } else {
        // Wartość jednokrotna.

        // eslint-disable-next-line no-lonely-if
        if (setNullWhenValueIsEmpty) {
          result.push({
            name: key,
            value: values[key] || null,
          });
        } else {
          result.push({
            name: key,
            value: values[key],
          });
        }
      }

      break;
    }
    case 'integer':
    case 'number': {
      if (isArray(values[key])) {
        result.push({
          name: key,
          values: values[key].map((value) => value?.toString()),
        });
      } else {
        result.push({
          name: key,
          value: values[key]?.toString(),
        });
      }

      break;
    }
    case 'object': {
      // Sekcje pomijamy (służą tylko i wyłącznie do wizualnego grupowania pól).
      break;
    }
    default: {
      if (isArray(values[key])) {
        result.push({
          name: key,
          values: values[key],
        });
      } else {
        result.push({
          name: key,
          value: values[key],
        });
      }

      break;
    }
  }
};

const convertNestedFieldToApiFormat = (result, schema, uiSchema, currentSchemaKey, values, key) => {
  const nestedFieldType = get(schema, [...currentSchemaKey, 'type']);

  let nestedField = null;

  if (nestedFieldType === 'array') {
    // Obsługa WIELOKROTNYCH pól zagnieżdżonych.

    nestedField = {
      name: key,
      nestedcollection: [],
    };

    const fields = [];

    values[key]?.forEach((field) => {
      const nestedcollectionContent = {
        id: field._id, // eslint-disable-line no-underscore-dangle
        fields: [],
      };

      fields.push(nestedcollectionContent);

      Object.keys(field).filter((property) => !property.startsWith('_')).forEach((property) => {
        let nestedSubFieldType = get(schema, [...currentSchemaKey, 'items', 'properties', property, 'type']);
        let nestedSubFieldWidget = get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), 'items', property, 'ui:widget']);
        if (nestedSubFieldType === 'array') {
          nestedSubFieldType = get(schema, [...currentSchemaKey, 'items', 'properties', property, 'items', 'type']);
          nestedSubFieldWidget = get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), 'items', property, 'items', 'ui:widget']);
        }

        if (nestedSubFieldWidget !== 'AdditionalFieldWidget') {
          switch (nestedSubFieldType) {
            case 'string': {
              const format = get(schema, [...currentSchemaKey, 'items', 'properties', property, 'format']);
              if (format === 'data-url') {
                if (field[property]) {
                  const value = field[property].split(';');
                  nestedcollectionContent.fields.push({
                    name: property,
                    value: value[2].substring(value[2].indexOf(',') + 1),
                    fileName: value[1].substring(value[1].indexOf('=') + 1),
                  });

                  break;
                }
              }

              let setNullWhenValueIsEmpty = false;

              if (
                nestedSubFieldWidget
                && [
                  'DateFieldWidget',
                  'DateTimeFieldWidget',
                  'TimeFieldWidget',
                  'ContactFieldWidget',
                  'ExternalOrganizationFieldWidget',
                  'ExternalUserFieldWidget',
                  'OrganizationUnitFieldWidget',
                  'UserFieldWidget',
                ].includes(nestedSubFieldWidget)
              ) {
                setNullWhenValueIsEmpty = true;
              }

              if (isArray(field[property])) {
                // Wartość wielokrotna.

                if (setNullWhenValueIsEmpty) {
                  nestedcollectionContent.fields.push({
                    name: property,
                    values: field[property].map((value) => value || null),
                  });
                } else {
                  nestedcollectionContent.fields.push({
                    name: property,
                    values: field[property],
                  });
                }
              } else {
                // Wartość jednokrotna.

                // eslint-disable-next-line no-lonely-if
                if (setNullWhenValueIsEmpty) {
                  nestedcollectionContent.fields.push({
                    name: property,
                    value: field[property] || null,
                  });
                } else {
                  nestedcollectionContent.fields.push({
                    name: property,
                    value: field[property],
                  });
                }
              }

              break;
            }
            case 'number': {
              if (isArray(field[property])) {
                // Wartość wielokrotna.

                nestedcollectionContent.fields.push({
                  name: property,
                  values: field[property].map((value) => value?.toString()),
                });
              } else {
                // Wartość jednokrotna.

                nestedcollectionContent.fields.push({
                  name: property,
                  value: field[property]?.toString(),
                });
              }

              break;
            }
            default: {
              if (isArray(field[property])) {
                // Wartość wielokrotna.

                nestedcollectionContent.fields.push({
                  name: property,
                  values: field[property],
                });
              } else {
                // Wartość jednokrotna.

                nestedcollectionContent.fields.push({
                  name: property,
                  value: field[property],
                });
              }

              break;
            }
          }
        }
      });
    });

    nestedField.nestedcollection.push(...fields);

    result.push(nestedField);
  } else {
    // Obsługa JEDNOKROTNYCH pól zagnieżdżonych.

    nestedField = {
      name: key,
      nested: {
        fields: [],
      },
    };

    const fields = [];

    if (values[key]) {
      Object.keys(values[key]).forEach((property) => {
        let nestedSubFieldType = get(schema, [...currentSchemaKey, 'properties', property, 'type']);
        let nestedSubFieldWidget = get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), property, 'ui:widget']);
        if (nestedSubFieldType === 'array') {
          nestedSubFieldType = get(schema, [...currentSchemaKey, 'properties', property, 'items', 'type']);
          nestedSubFieldWidget = get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), property, 'items', 'ui:widget']);
        }

        if (nestedSubFieldWidget !== 'AdditionalFieldWidget') {
          switch (nestedSubFieldType) {
            case 'string': {
              const format = get(schema, [...currentSchemaKey, 'properties', property, 'format']);
              if (format === 'data-url') {
                if (values[key][property]) {
                  const value = values[key][property].split(';');
                  fields.push({
                    name: property,
                    value: value[2].substring(value[2].indexOf(',') + 1),
                    fileName: value[1].substring(value[1].indexOf('=') + 1),
                  });

                  break;
                }
              }

              let setNullWhenValueIsEmpty = false;

              if (
                nestedSubFieldWidget
                && [
                  'DateFieldWidget',
                  'DateTimeFieldWidget',
                  'TimeFieldWidget',
                  'ContactFieldWidget',
                  'ExternalOrganizationFieldWidget',
                  'ExternalUserFieldWidget',
                  'OrganizationUnitFieldWidget',
                  'UserFieldWidget',
                ].includes(nestedSubFieldWidget)
              ) {
                setNullWhenValueIsEmpty = true;
              }

              if (isArray(values[key][property])) {
                // Wartość wielokrotna.

                if (setNullWhenValueIsEmpty) {
                  fields.push({
                    name: property,
                    values: values[key][property].map((value) => value || null),
                  });
                } else {
                  fields.push({
                    name: property,
                    values: values[key][property],
                  });
                }
              } else {
                // Wartość jednokrotna.

                // eslint-disable-next-line no-lonely-if
                if (setNullWhenValueIsEmpty) {
                  fields.push({
                    name: property,
                    value: values[key][property] || null,
                  });
                } else {
                  fields.push({
                    name: property,
                    value: values[key][property],
                  });
                }
              }

              break;
            }
            case 'number': {
              if (isArray(values[key][property])) {
                // Wartość wielokrotna.

                fields.push({
                  name: property,
                  values: values[key][property].map((value) => value?.toString()),
                });
              } else {
                // Wartość jednokrotna.

                fields.push({
                  name: property,
                  value: values[key][property]?.toString(),
                });
              }

              break;
            }
            default: {
              if (isArray(values[key][property])) {
                // Wartość wielokrotna.

                fields.push({
                  name: property,
                  values: values[key][property],
                });
              } else {
                // Wartość jednokrotna.

                fields.push({
                  name: property,
                  value: values[key][property],
                });
              }

              break;
            }
          }
        }
      });
    }

    nestedField.nested.fields.push(...fields);

    result.push(nestedField);
  }
};

// Funkcja odpowiedzialna za konwersję wartości zapisanych w formularzu do postaci obsługiwanej przez API.
const convertToApiFormat = (result, schema, uiSchema, schemaKey, values) => {
  if (Object.keys(values).length > 0) {
    Object.keys(values).forEach((key) => {
      let currentSchemaKey = [];
      if (schemaKey) {
        currentSchemaKey = [
          ...schemaKey,
          'properties',
          key,
        ];
      } else {
        currentSchemaKey = [
          'properties',
          key,
        ];
      }

      if (get(uiSchema, [...currentSchemaKey.filter((currentSchemaKeyPart) => currentSchemaKeyPart !== 'properties'), 'ui:widget']) !== 'AdditionalFieldWidget') {
        if (get(schema, [...currentSchemaKey, 'nested'])) {
          // Obsługa pól zagnieżdżonych.

          convertNestedFieldToApiFormat(result, schema, uiSchema, currentSchemaKey, values, key);
        } else if (isObject(values[key]) && !isArray(values[key])) {
          // Obsługa pól zdefiniowanych w sekcjach.

          convertToApiFormat(result, schema, uiSchema, currentSchemaKey, values[key]);
        } else {
          // Obsługa pól standardowych.

          convertFieldToApiFormat(result, schema, uiSchema, currentSchemaKey, values, key);
        }
      }
    });
  }
};

// Przygotowanie danych do wysłania i określenie które pola uległy zmianie
export const prepareQuestionnaireToSave = (questionnaireData, initialQuestionnaireData, schema, uiSchema) => {
  const fieldsToSave = {};

  // Przesyłamy tylko zmodyfikowane wartości (bez tych zapisanych w kopii roboczej).
  Object.keys(questionnaireData).forEach((key) => {
    // Tymczasowe obejście. Właściwość "forceUpdate" wykorzystywana jest do "siłowego" odświeżania formularza.
    if (key !== 'forceUpdate') {
      fieldsToSave[key] = questionnaireData[key];
    }
  });

  const mappedData = [];
  convertToApiFormat(mappedData, schema, uiSchema, [], fieldsToSave);

  return { fields: mappedData };
};

export const mapQuestionnaires = (questionnaires, selectedMenuItem) => {
  const mappedQuestionnaires = questionnaires.map((questionnaireItem) => ({
    id: questionnaireItem.id,
    title: questionnaireItem.name,
    description: questionnaireItem.description,
    approvalDate: questionnaireItem.approvalDate,
    assignedToExternalOrganizationDate: questionnaireItem.assignedToExternalOrganizationDate,
    creationDate: questionnaireItem.creationDate,
    receivedFromExternalOrganizationDate: questionnaireItem.receivedFromExternalOrganizationDate,
    returnedToExternalOrganizationDate: questionnaireItem.returnedToExternalOrganizationDate,
    returnDescription: questionnaireItem.returnDescription,
  }));

  if (mappedQuestionnaires.length > 0 && selectedMenuItem === MENU_ITEM__QUESTIONNAIRES__AVAILABLE) {
    // Pobranie z localStorage informacji nt. wysłanych ankiet.
    const sentQuestionnaires = localStorage.getItem('questionnaires:sent');
    const sentQuestionnairesList = sentQuestionnaires ? JSON.parse(sentQuestionnaires) : [];

    return mappedQuestionnaires.filter((value) => (!sentQuestionnairesList.includes(value.id)));
  }

  return mappedQuestionnaires;
};

// Funkcja odpowiedzialna za zwrócenie ścieżki do sekcji zdefiniowanej w schemacie.
// Przykład: ['properties', 'section0', 'properties', 'section0_0'].
export const getPathToSectionInSchema = (result, currentPath, sectionId, schema) => {
  const keys = Object.keys(schema.properties);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (key === sectionId) {
      if (currentPath && currentPath.length > 0) {
        currentPath.forEach((currentPathPart) => result.push(currentPathPart));
        result.push('properties');
        result.push(key);
      } else {
        result.push('properties');
        result.push(key);
      }
      break;
    } else if (schema.properties[key].type === 'object' && schema.properties[key].properties) {
      let newCurrentPath = ['properties', key];
      if (currentPath && currentPath.length > 0) {
        newCurrentPath = [
          ...currentPath,
          ...newCurrentPath,
        ];
      }
      getPathToSectionInSchema(result, newCurrentPath, sectionId, schema.properties[key]);
    } else if (schema.properties[key].type === 'array' && schema.properties[key].items.properties) {
      let newCurrentPath = ['properties', key, 'items'];
      if (currentPath && currentPath.length > 0) {
        newCurrentPath = [
          ...currentPath,
          ...newCurrentPath,
        ];
      }
      getPathToSectionInSchema(result, newCurrentPath, sectionId, schema.properties[key].items);
    }
  }
};

export const getFieldLimitationsErrors = (uiSchema, formData, errors, parentId) => {
  Object.keys(uiSchema).forEach((elementId) => {
    if (elementId.startsWith('section')) {
      getFieldLimitationsErrors(uiSchema[elementId], formData, errors, parentId ? `${parentId}.${elementId}` : elementId);
    } else if (!elementId.startsWith('ui:')) {
      const limitations = uiSchema[elementId]['ui:options']?.limitations;
      if (limitations) {
        limitations.forEach((limitation) => {
          const value1 = get(formData, parentId ? `${parentId}.${elementId}` : elementId);
          const value2 = get(formData, limitation.fieldId);
          switch (limitation.condition) {
            case 'Equal': {
              if (value1 !== value2) {
                errors.push(
                  {
                    name: 'limitations',
                    message: `Wartość musi być równa wartości zdefiniowanej w polu "${limitation.fieldId.includes('.') ? limitation.fieldId.substring(limitation.fieldId.lastIndexOf('.') + 1) : limitation.fieldId}".`,
                    property: parentId
                      ? `.${parentId}.${elementId}`
                      : `.${elementId}`,
                  },
                );
              }
              break;
            }
            case 'Greater': {
              if (value1 <= value2) {
                errors.push(
                  {
                    name: 'limitations',
                    message: `Wartość musi być większa od wartości zdefiniowanej w polu "${limitation.fieldId.includes('.') ? limitation.fieldId.substring(limitation.fieldId.lastIndexOf('.') + 1) : limitation.fieldId}".`,
                    property: parentId
                      ? `.${parentId}.${elementId}`
                      : `.${elementId}`,
                  },
                );
              }
              break;
            }
            case 'GreaterOrEqual': {
              if (value1 < value2) {
                errors.push(
                  {
                    name: 'limitations',
                    message: `Wartość musi być większa lub równa wartości zdefiniowanej w polu "${limitation.fieldId.includes('.') ? limitation.fieldId.substring(limitation.fieldId.lastIndexOf('.') + 1) : limitation.fieldId}".`,
                    property: parentId
                      ? `.${parentId}.${elementId}`
                      : `.${elementId}`,
                  },
                );
              }
              break;
            }
            case 'Less': {
              if (value1 >= value2) {
                errors.push(
                  {
                    name: 'limitations',
                    message: `Wartość musi być mniejsza od wartości zdefiniowanej w polu "${limitation.fieldId.includes('.') ? limitation.fieldId.substring(limitation.fieldId.lastIndexOf('.') + 1) : limitation.fieldId}".`,
                    property: parentId
                      ? `.${parentId}.${elementId}`
                      : `.${elementId}`,
                  },
                );
              }
              break;
            }
            case 'LessOrEqual': {
              if (value1 > value2) {
                errors.push(
                  {
                    name: 'limitations',
                    message: `Wartość musi być mniejsza lub równa wartości zdefiniowanej w polu "${limitation.fieldId.includes('.') ? limitation.fieldId.substring(limitation.fieldId.lastIndexOf('.') + 1) : limitation.fieldId}".`,
                    property: parentId
                      ? `.${parentId}.${elementId}`
                      : `.${elementId}`,
                  },
                );
              }
              break;
            }
            default:
              break;
          }
        });
      }
    }
  });
};
